import React from 'react';
import DataTables from '../../CommonDataTable/DataTable';
import config from '../../../../config/config';
import apiCalls from '../../../../config/apiCalls'
import ViewModal from '../../CommonModals/viewModal';
import NewUserModal from '../../CommonModals/NewUserModal';
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage';
import FormModal from '../../../Form/FormModal';
import store from '../../../App/store';
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service"
import RolePermissions from '../../CommonModals/Permissions';
// config file
export default class Teachers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageData: '',
      rolePermission: "",
      rolesList: [],
      editSelectedRecord:window.location.href.includes("edit"),
      addSelectedRecord:window.location.href.includes("create"),
      viewSelectedRecord:window.location.href.includes("view"),	
    };
    this.getRoleListFromServer()
  }

  static getDerivedStateFromProps(props, state) {
    let storeData = store.getState()
    let languageData = storeData && storeData.settingsData && storeData.settingsData.settings && storeData.settingsData.settings.languageTranslation ? storeData.settingsData.settings.languageTranslation : ""
    return { languageData: languageData };
  }
  componentDidMount = () => {
    //Screen permisions value can be edit,view, no view
    let screenPermissions = RolePermissions.screenPermissions('Patients');
    if (screenPermissions) {
      this.setState({
        rolePermission: screenPermissions
      })
    }
    // this.getRoleListFromServer()
  }
  setData = (props) => {
    let rowData = {}
    if (props && props.match && props.match.params && props.match.params.id) {
      rowData["_id"] = JSON.parse(props.match.params.id)
      return rowData
    }
  }
  getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest('GET', url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = []
          for (let obj of res.roles) {
            if (obj.role) rolesList.push({ value: obj.role, label: obj.role });
          }

          await this.setState({ rolesList: rolesList });
        }
      }).catch((err) => { return err })
  };
  getTableFields = () => {
    let { languageData } = this.state
    let roleTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Admin',
        value: 'Admin'
      },
      {
        label: 'Super Admin',
        value: 'Super Admin'
      },
      {
        label: 'User',
        value: 'User'
      },
    ];
    let StatusTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      }
    ];
    let data = [
      {
        "textAlign": "center",
        "width": 47,
        "field": "Check Box",
        "label": "Check Box",
        "fieldType": "multiple",
        "header": "",
        "selectionMode": "multiple",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "textAlign": "center",
        "width": 47,
        "field": "Sno",
        "label": "SNo",
        "header": "SNo",
        "filter": false,
        "sortable": false,
        "placeholder": "Search",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "displayName",
        "type": "text",
        "placeholder": "Name",
        "label": "Name",
        "header": "Name",
        "width": 120,
        "id": "name",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "textAlign": "Center",
        "globalSearchField": "true",
        "show": true,
        "field": "displayName",
        "mobile": true,
        "filter": true,
        "displayInSettings": true,
        "sortable": true
      },
      {
        "name": "email",
        "type": "email",
        "placeholder": "Email",
        "label": "Email",
        "width": "180px",
        "header": "Email",
        "derivedValue": "email=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "email",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "email",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "phone",
        "type": "text",
        "placeholder": "Phone",
        "label": "Phone",
        "width": "120px",
        "header": "Phone",
        "derivedValue": "phone=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "phone",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "filter": true,
        "textAlign": "Center",
        "show": true,
        "field": "phone",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "Link",
        "style": {
          "color": "#0e4768",
          "cursor": "pointer",
          "textTransform": "capitalize"
        }
      },
      {
        "name": "dob",
        "type": "date",
        "placeholder": "DOB",
        "label": "DOB",
        "width": "100px",
        "header": "DOB",
        "derivedValue": "dob=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "dob",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "field": "dob",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true
      },
      {
        "name": "physicianName",
        "type": "text",
        "placeholder": "Physician",
        "label": "Physician",
        "width": "120px",
        "header": "Physician",
        "derivedValue": "physician=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "physicianName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1008,
        "searchField": "displayName",
        "fieldType": "text",
        "populteFields": [],
        "displayFields": [
          "displayName"
        ],
        "controllerName": "hospitalemployee",
        "searchApi": "hospitalemployees",
        "isMultiple": false,
        "textAlign": "Center",
        "show": true,
        "field": "physicianName",
        "showOrHideFields": [],
        "fieldName": "physicianName",
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      // {
      //   "name": "hospitalemployee_Name",
      //   "type": "text",
      //   "placeholder": "hospitalemployee_Name",
      //   "label": "hospitalemployee_Name",
      //   "header": "hospitalemployee Name",
      //   "width": 110,
      //   "parentField": "physician",
      //   "id": "hospitalemployee_Name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "Name",
      //   "show": true,
      //   "field": "hospitalemployee_Name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "comment",
        "type": "textarea",
        "placeholder": "Comment",
        "label": "Comment",
        "width": "200px",
        "header": "Comment",
        "derivedValue": "comment=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "comment",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "comment",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      {
        "name": "gender",
        "type": "dropDown",
        "placeholder": "Gender",
        "label": "Gender",
        "width": "90px",
        "header": "Gender",
        "derivedValue": "gender=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "gender",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "options": [
          {
            "label": "Male",
            "value": "Male",
            "color": "primary"
          },
          {
            "label": "Female",
            "value": "Female",
            "color": "primary"
          },
          {
            "label": "Other",
            "value": "Other",
            "color": "primary"
          }
        ],
        "fieldType": "dropDown",
        "dependent": [],
        "textAlign": "Center",
        "show": true,
        "field": "gender",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,        
        "filter":true
      },
      {
        "name": "hospitalName",
        "type": "text",
        "placeholder": "Provider",
        "label": "Provider",
        "width": "150px",
        "header": "Provider",
        "derivedValue": "hospital=undefined",
        "capitalizeTableText": false,        
        "actions": [],
        "actionsNumber": [],
        "id": "hospitalName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1010,
        "searchField": "name",
        "fieldType": "text",
        "populteFields": [],
        "displayFields": [
          "name"
        ],
        "controllerName": "providers",
        "searchApi": "providerss",
        "isMultiple": false,
        "textAlign": "Center",
        "show": true,
        "field": "hospitalName",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "sortable":true,
        "filter":true
      },
      // {
      //   "name": "providers_name",
      //   "type": "text",
      //   "placeholder": "providers_name",
      //   "label": "providers_name",
      //   "header": "providers name",
      //   "width": 110,
      //   "parentField": "hospital",
      //   "id": "providers_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "providers_name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "payCare",
      //   "type": "dropDown",
      //   "placeholder": "Pay Care",
      //   "label": "Pay Care",
      //   "width": "130px",
      //   "addFormOrder": 15,
      //   "editFormOrder": 15,
      //   "header": "Pay Care",
      //   "derivedValue": "payCare=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": true,
      //   "filter": true,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "payCare",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "false",
      //   "controllerId": null,
      //   "options": [
      //     {
      //       "label": "Self",
      //       "value": "Self",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Managed Care",
      //       "value": "Managed Care",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Medicare",
      //       "value": "Medicare",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Medicaid",
      //       "value": "Medicaid",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Fault Cases PIP",
      //       "value": "Fault Cases PIP",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Workmans Comp",
      //       "value": "Workmans Comp",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Slip & Fall",
      //       "value": "Slip & Fall",
      //       "color": "primary"
      //     }
      //   ],
      //   "fieldType": "dropDown",
      //   "filterElement": [
      //     {
      //       "label": "Self",
      //       "value": "Self",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Managed Care",
      //       "value": "Managed Care",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Medicare",
      //       "value": "Medicare",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Medicaid",
      //       "value": "Medicaid",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Fault Cases PIP",
      //       "value": "Fault Cases PIP",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Workmans Comp",
      //       "value": "Workmans Comp",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Slip & Fall",
      //       "value": "Slip & Fall",
      //       "color": "primary"
      //     }
      //   ],
      //   "dependent": [],
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "payCare",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "facility",
      //   "type": "relateAutoComplete",
      //   "placeholder": "Facility",
      //   "label": "Facility",
      //   "width": "90px",
      //   "header": "Facility",
      //   "derivedValue": "facility=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "facility",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "false",
      //   "controllerId": 1011,
      //   "searchField": "name",
      //   "fieldType": "relateAutoComplete",
      //   "populteFields": [],
      //   "displayFields": [
      //     "name"
      //   ],
      //   "controllerName": "facilities",
      //   "searchApi": "facilitiess",
      //   "isMultiple": false,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "facility",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "facilities_name",
      //   "type": "text",
      //   "placeholder": "facilities_name",
      //   "label": "facilities_name",
      //   "header": "facilities name",
      //   "width": 110,
      //   "parentField": "facility",
      //   "id": "facilities_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "facilities_name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "driverLicense",
        "type": "profile",
        "placeholder": "Driver License",
        "label": "Driver License",
        "width": "130px",
        "header": "Driver License",
        "derivedValue": "driverLicense=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "driverLicense",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "imagePath": "patients",
        "textAlign": "Center",
        "show": true,
        "field": "driverLicense",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "insuranceCard",
        "type": "profile",
        "placeholder": "Insurance Card",
        "label": "Insurance Card",
        "width": "130px",
        "header": "Insurance Card",
        "derivedValue": "insuranceCard=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "insuranceCard",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "imagePath": "patients",
        "textAlign": "Center",
        "show": true,
        "field": "insuranceCard",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": 120,
        "header": "Created",
        "derivedValue": "created=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "created",
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "date",
        "sortable":true,
        "filter":true
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": 120,
        "header": "Updated",
        "derivedValue": "updated=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "updated",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "updated",
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "date",
        "sortable":true,
        "filter":true
      },
      {
        "name": "createdByName",
        "type": "Text",
        "placeholder": "Created By",
        "label": "Created By",
        "width": 120,
        "header": "Created By",
        "id": "createdByName",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "field": "createdByName",
        "mobile": true,
        "filter": true,
        "displayInSettings": true
      },
      {
        "name": "updatedByName",
        "type": "Text",
        "placeholder": "Updated By",
        "label": "Updated By",
        "width": 120,
        "header": "Updated By",
        "id": "updatedByName",
        "displayinlist": "true",
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "filter": true,
        "field": "updatedByName",
        "mobile": true,
        "displayInSettings": true
      },
    ]
       return data;
  };

  getFormFields = () => {
    let { languageData } = this.state
    let statusTypes = [
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      },
    ];
    return ([
      {
        "name": "firstName",
        "type": "text",
        "placeholder": "First Name",
        "label": "First Name",
        "width": 110,
        "id": "firstName",
        "displayinaddForm": "true",
        "required": true,
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "globalSearchField": "true",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder": 1,
        "editFormOrder": 1,
        "gridTake":3 
      },
      {
        "name": "lastName",
        "type": "text",
        "placeholder": "Last Name",
        "label": "Last Name",
        "width": 110,
        "id": "lastName",
        "required": true,
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "globalSearchField": "true",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder": 2,
        "editFormOrder": 2,
        "gridTake":3 
      },
      {
        "name": "name",
        "type": "text",
        "placeholder": "Name",
        "label": "Name",
        "width": 110,
        "id": "name",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "globalSearchField": "true",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "email",
        "type": "email",
        "placeholder": "Email",
        "label": "Email",
        "width": "90px",
        "derivedValue": "email=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "email",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder": 4,
        "editFormOrder": 4,
        "gridTake":3 
      },
      {
        "name": "phone",
        "type": "text",
        "placeholder": "Phone",
        "label": "Phone",
        "width": "90px",
        "derivedValue": "phone=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "phone",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": true,
        "formatType": "US",
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "Link",
        "style": {
          "color": "#0e4768",
          "cursor": "pointer",
          "textTransform": "capitalize"
        },
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder": 3,
        "editFormOrder": 3,
        "gridTake":3 
      },
      {
        "name": "dob",
        "type": "date",
        "placeholder": "DOB",
        "label": "DOB",
        "width": "90px",
        "derivedValue": "dob=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "dob",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder": 6,
        "editFormOrder": 6,
        "gridTake":3 ,
        "maxDate": new Date()
      },
      {
        "name": "physician",
        "type": "relateAutoComplete",
        "placeholder": "Physician",
        "label": "Physician",
        "width": "90px",
        "derivedValue": "physician=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "physician",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1008,
        "searchField": "displayName",
        "fieldType": "relateAutoComplete",
        "populteFields": [
          
        ],
        "displayFields": [
          "displayName"
        ],
        "controllerName": "hospitalemployee",
        "searchApi": "provideremployees",
        "isMultiple": false,
        "show": true,
        "showOrHideFields": [
          
        ],
        "fieldName": "physician",
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder": 7,
        "editFormOrder": 7,
        "gridTake":3 
      },
      {
        "name": "comment",
        "type": "textarea",
        "placeholder": "Comment",
        "label": "Comment",
        "width": "90px",
        "derivedValue": "comment=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "comment",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": false
      },
      {
        "name": "gender",
        "type": "dropDown",
        "placeholder": "Gender",
        "label": "Gender",
        "width": "90px",
        "derivedValue": "gender=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "gender",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "addFormOrder": 5,
        "editFormOrder": 5,
        "options": [
          {
            "label": "Male",
            "value": "Male",
            "color": "primary"
          },
          {
            "label": "Female",
            "value": "Female",
            "color": "primary"
          },
          {
            "label": "Other",
            "value": "Other",
            "color": "primary"
          }
        ],
        "fieldType": "dropDown",
        "dependent": [
          
        ],
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "gridTake":3 
      },
      {
        "name": "hospital",
        "type": "relateAutoComplete",
        "placeholder": "Provider",
        "label": "Provider",
        "width": "90px",
        "derivedValue": "hospital=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "hospital",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1010,
        "searchField": "name",
        "fieldType": "relateAutoComplete",
        "populteFields": [
          
        ],
        "displayFields": [
          "name"
        ],
        "controllerName": "providers",
        "searchApi": "providerss",
        "isMultiple": false,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder": 8,
        "editFormOrder": 8, 
        "gridTake":3        
      },
      // {
      //   "name": "payCare",
      //   "type": "dropDown",
      //   "placeholder": "Pay Care",
      //   "label": "Pay Care",
      //   "width": "90px",
      //   "addFormOrder": 15,
      //   "editFormOrder": 15,
      //   "derivedValue": "payCare=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": true,
      //   "filter": true,
      //   "actions": [
          
      //   ],
      //   "actionsNumber": [
          
      //   ],
      //   "id": "payCare",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "false",
      //   "controllerId": null,
      //   "options": [
      //     {
      //       "label": "Self",
      //       "value": "Self",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Managed Care",
      //       "value": "Managed Care",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Medicare",
      //       "value": "Medicare",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Medicaid",
      //       "value": "Medicaid",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Fault Cases PIP",
      //       "value": "Fault Cases PIP",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Workmans Comp",
      //       "value": "Workmans Comp",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Slip & Fall",
      //       "value": "Slip & Fall",
      //       "color": "primary"
      //     }
      //   ],
      //   "fieldType": "dropDown",
      //   "filterElement": [
      //     {
      //       "label": "Self",
      //       "value": "Self",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Managed Care",
      //       "value": "Managed Care",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Medicare",
      //       "value": "Medicare",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Medicaid",
      //       "value": "Medicaid",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Fault Cases PIP",
      //       "value": "Fault Cases PIP",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Workmans Comp",
      //       "value": "Workmans Comp",
      //       "color": "primary"
      //     },
      //     {
      //       "label": "Slip & Fall",
      //       "value": "Slip & Fall",
      //       "color": "primary"
      //     }
      //   ],
      //   "dependent": [
          
      //   ],
      //   "show": true,
      //   "showOrHideFields": [
          
      //   ],
      //   "mobile": true,
      //   "displayInSettings": true,
      //   "isAddFormHidden": false,
      //   "isEditFormHidden": false,
      //   "gridTake":3 
      // },
      {
        "name": "facility",
        "type": "relateAutoComplete",
        "placeholder": "Facility",
        "label": "Facility",
        "width": "90px",
        "derivedValue": "facility=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "facility",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1011,
        "searchField": "name",
        "fieldType": "relateAutoComplete",
        "populteFields": [
          
        ],
        "displayFields": [
          "name"
        ],
        "controllerName": "facilities",
        "searchApi": "facilitiess",
        "isMultiple": false,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "disable":true,
        "gridTake":3 
      },
      {
        "name": "driverLicense",
        "type": "profile",
        "placeholder": "Driver License",
        "label": "Driver License",
        "width": "90px",
        "derivedValue": "driverLicense=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "driverLicense",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "imagePath": "patients",
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "gridTake":3 
      },
      {
        "name": "insuranceCard",
        "type": "profile",
        "placeholder": "Insurance Card",
        "label": "Insurance Card",
        "width": "90px",
        "derivedValue": "driverLicense=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "insuranceCard",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "imagePath": "patients",
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "gridTake":3 
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": 90,
        "derivedValue": "created=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": 90,
        "derivedValue": "updated=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "updated",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "createdBy",
        "type": "relateAutoComplete",
        "placeholder": "CreatedBy",
        "label": "CreatedBy",
        "width": 90,
        "disabled": true,
        "derivedValue": "createdBy=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "createdBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "name",
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updatedBy",
        "type": "relateAutoComplete",
        "placeholder": "UpdatedBy",
        "label": "UpdatedBy",
        "width": 90,
        "derivedValue": "updatedBy=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "updatedBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "name",
        "disabled": true,
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      }
    ]);
  }

  submit = async (item) => {

    this.setState({ isOpenFormModal: true })
    await this.formModalRef.getRowData(item, 'edit');

    console.log("Submit Button in sode          ")
  }
  getMobileTableFields = () => {
    let data = [{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"name","type":"text","placeholder":"Name","label":"Name","header":"Name","width":110,"id":"name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"fieldType":"Link","textAlign":"Center","globalSearchField":"true","show":true,"field":"name","mobile":true,"displayInSettings":true},{"name":"email","type":"email","placeholder":"Email","label":"Email","width":"90px","header":"Email","derivedValue":"email=undefined","capitalizeTableText":false,"sortable":true,"filter":true,"actions":[],"actionsNumber":[],"id":"email","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"email","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"phone","type":"text","placeholder":"Phone","label":"Phone","width":"90px","header":"Phone","derivedValue":"phone=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"phone","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"phone","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"dob","type":"date","placeholder":"DOB","label":"DOB","width":"90px","header":"DOB","derivedValue":"dob=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"dob","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","show":true,"field":"dob","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"physician","type":"relateAutoComplete","placeholder":"Physician","label":"Physician","width":"90px","header":"Physician","derivedValue":"physician=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"physician","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1008,"searchField":"Name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":["Name"],"controllerName":"hospitalemployee","searchApi":"hospitalemployees","isMultiple":false,"textAlign":"Center","show":true,"field":"physician","showOrHideFields":[],"fieldName":"physician","mobile":true,"displayInSettings":true},{"name":"hospitalemployee_Name","type":"text","placeholder":"hospitalemployee_Name","label":"hospitalemployee_Name","header":"hospitalemployee Name","width":110,"parentField":"physician","id":"hospitalemployee_Name","displayinlist":"true","fieldType":"RACSubField","textAlign":"Center","subFieldName":"Name","show":true,"field":"hospitalemployee_Name","mobile":true,"displayInSettings":true},{"name":"comment","type":"textarea","placeholder":"Comment","label":"Comment","width":"90px","header":"Comment","derivedValue":"comment=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"comment","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"comment","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"gender","type":"dropDown","placeholder":"Gender","label":"Gender","width":"90px","header":"Gender","derivedValue":"gender=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"gender","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"Male","value":"Male","color":"primary"},{"label":"Female","value":"Female","color":"primary"}],"fieldType":"dropDown","dependent":[],"textAlign":"Center","show":true,"field":"gender","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"hospital","type":"relateAutoComplete","placeholder":"Hospital","label":"Hospital","width":"90px","header":"Hospital","derivedValue":"hospital=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"hospital","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1010,"searchField":"name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":["name"],"controllerName":"providers","searchApi":"providerss","isMultiple":false,"textAlign":"Center","show":true,"field":"hospital","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"providers_name","type":"text","placeholder":"providers_name","label":"providers_name","header":"providers name","width":110,"parentField":"hospital","id":"providers_name","displayinlist":"true","fieldType":"RACSubField","textAlign":"Center","subFieldName":"name","show":true,"field":"providers_name","mobile":true,"displayInSettings":true},{"name":"payCare","type":"dropDown","placeholder":"Pay Care","label":"Pay Care","width":"90px","addFormOrder":15,"editFormOrder":15,"header":"Pay Care","derivedValue":"payCare=undefined","capitalizeTableText":false,"sortable":true,"filter":true,"actions":[],"actionsNumber":[],"id":"payCare","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"options":[{"label":"Self","value":"Self","color":"primary"},{"label":"Managed Care","value":"Managed Care","color":"primary"},{"label":"Medicare","value":"Medicare","color":"primary"},{"label":"Medicaid","value":"Medicaid","color":"primary"},{"label":"Fault Cases PIP","value":"Fault Cases PIP","color":"primary"},{"label":"Workmans Comp","value":"Workmans Comp","color":"primary"},{"label":"Slip & Fall","value":"Slip & Fall","color":"primary"}],"fieldType":"dropDown","filterElement":[{"label":"Self","value":"Self","color":"primary"},{"label":"Managed Care","value":"Managed Care","color":"primary"},{"label":"Medicare","value":"Medicare","color":"primary"},{"label":"Medicaid","value":"Medicaid","color":"primary"},{"label":"Fault Cases PIP","value":"Fault Cases PIP","color":"primary"},{"label":"Workmans Comp","value":"Workmans Comp","color":"primary"},{"label":"Slip & Fall","value":"Slip & Fall","color":"primary"}],"dependent":[],"textAlign":"Center","show":true,"field":"payCare","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"facility","type":"relateAutoComplete","placeholder":"Facility","label":"Facility","width":"90px","header":"Facility","derivedValue":"facility=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"facility","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1011,"searchField":"name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":["name"],"controllerName":"facilities","searchApi":"facilitiess","isMultiple":false,"textAlign":"Center","show":true,"field":"facility","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"facilities_name","type":"text","placeholder":"facilities_name","label":"facilities_name","header":"facilities name","width":110,"parentField":"facility","id":"facilities_name","displayinlist":"true","fieldType":"RACSubField","textAlign":"Center","subFieldName":"name","show":true,"field":"facilities_name","mobile":true,"displayInSettings":true},{"name":"driverLicense","type":"profile","placeholder":"Driver License","label":"Driver License","width":"90px","header":"Driver License","derivedValue":"driverLicense=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"driverLicense","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"imagePath":"patients","textAlign":"Center","show":true,"field":"driverLicense","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"name":"createdBy","type":"relateAutoComplete","placeholder":"CreatedBy","label":"CreatedBy","width":90,"disabled":true,"header":"CreatedBy","derivedValue":"createdBy=undefined","actions":[],"actionsNumber":[],"id":"createdBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"createdBy","mobile":true,"displayInSettings":true},{"name":"updatedBy","type":"relateAutoComplete","placeholder":"UpdatedBy","label":"UpdatedBy","width":90,"header":"UpdatedBy","derivedValue":"updatedBy=undefined","actions":[],"actionsNumber":[],"id":"updatedBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","disabled":true,"fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"updatedBy","mobile":true,"displayInSettings":true}]

    return data;
  };
  closeFormModal = async () => {
    this.setState({
      isOpenFormModal: false,
    })
  }
  // submit1 = item => {
  //   let x = patientssFields
  //   let objpatientss = {}

  //   objpatientss["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objpatientss[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objpatientss,
  //     newFormFields: formFields
  //   });
  // }
  
  cancelReset = async (type) => {
    this.setState({
      openNewUserModal: false
    });
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };
  getChangedRoleOptions = () => {
    let fields = this.getFormFields();
    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name == "role") {
          obj.options = this.state.rolesList && this.state.rolesList.length > 0 ? this.state.rolesList : []
        }
      }
    }
    return fields;
  }
  saveDataToServer = async (item, field, value) => {
    let body = item[0]
    body[field] = value
    let userBody = Object.assign({}, body);
    this.setState({
      isLoading: true
    });
    if (body) {
      let method, apiUrl;
      method = 'PUT';
      apiUrl = `${apiCalls.Patientss}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, 'success');

          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, 'error');
          }
          this.setState({
            isLoading: false
          });
        }).catch((err) => {
          return err;
        });
    } else {
      return;
    }
  }
  render() {
    return (
      <span>
        <DataTables
          {...this.props}
          onRef={ref => (this.dataTableRef = ref)}
          // MobileTableFields={this.getMobileTableFields}
          // getTableFields={this.getTableFields}
          // formFields={this.getFormFields}
          // 
addRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
editRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
deleteRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
viewRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
exportRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
sample={true}
          // globalSearch={'Display Name/Email'}
          // type='Patientss'
          // apiUrl={apiCalls.Patientss}
          getTableFields={this.getTableFields}
          formFields={this.getChangedRoleOptions}
          // exportRequried={true}

          printRequried={true}
          actionsTypes={[
            {
              'name': 'Edit',
              "options": [
                { 'label': 'Edit', 'value': 'Edit', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": false, },
              ]
            },
            {
              'name': 'Delete',
              "options": [
                { 'label': 'Delete', 'value': 'Delete', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": true, },
              ]
            },
            
            // {
            //   'name': 'Block',
            //   "options": [
            //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'ResetPassword',
            //   "options": [
            //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'Submit',
            //   'action': this.submit,
            //   "options": [
            //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
            //   ]
            // },
            // {
            //   name: "newModel",
            //   action: this.submit1,
            //   options: [
            //     { label: "newModel", value: "newModel", show: true, multiple: false }
            //   ]
            // }
            
          ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={true}
          exportToCsv={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          sampleFilePath={filePath.patientss}
          setData={this.setData}
          editSelectedRecord={this.state.editSelectedRecord}
          addSelectedRecord={this.state.addSelectedRecord}
          viewSelectedRecord={this.state.viewSelectedRecord}
          globalSearch={"name/email/phone/comment/gender"}
          type='Patients'
          routeTo={apiCalls.Patientss}
          displayViewOfForm='screen'
          apiResponseKey={apiCalls.Patientss}
          apiUrl={apiCalls.Patientss}

        />
        {this.state.isOpenFormModal ? (
          <FormModal
            onRef={(ref) => (this.formModalRef = ref)}
            formType="edit"
            openFormModal={this.state.isOpenFormModal}
            formFields={this.props.formFields}
          />

        ) : null}
        {this.state.openNewUserModal ? (
          <NewUserModal
            openNewUserModal={this.state.openNewUserModal}
            cancelReset={this.cancelReset}
            item={this.state.item}
            newFormFields={this.state.newFormFields}
            recordId={this.state.item._id}
            entityType="Patients"
            apiUrl={apiCalls.Patientss}
          />
        ) : null}
      </span>
    );
  }
}